import { useState } from "preact/hooks";
import { h, Fragment } from "preact";
import { Select } from "antd";
const { Option } = Select;

export const CheckboxTree = ({
                                 param,
                                 serviceId,
                                 updateCheckbox,
                                 updateSelectParam,
                             }) => {
    const [isScanParamsOpen, setIsScanParamsOpen] = useState(
        param?.paramName === "scan" ? param?.enabled : false
    );
    const handleCheckboxChange = (checked) => {
        updateCheckbox(serviceId, param.id, checked);
    };

    const handleSelectChange = (value) => {
        updateSelectParam(serviceId, param.id, value);
    };

    const isParentChecked =
        param.enabled ||
        (param.params && param.params.some((child) => child.enabled));

    return (
        <div
            style={{
                marginLeft: param.params && param.paramName == "egov-code" ? 0 : 20,
            }}
        >
            {param.paramName === "scan" ? (
                <div style={{ paddingTop: "10px" }}>
                    <input
                        id={`${serviceId}-${param.id}`}
                        type="checkbox"
                        checked={isParentChecked}
                        onChange={(e) => {
                            handleCheckboxChange(e.target.checked);
                            setIsScanParamsOpen(e.target.checked);
                        }}
                    />
                    <label
                        className="checkbox-select-label"
                        htmlFor={`${serviceId}-${param.id}`}
                        style={{ marginLeft: "10px", position: "static" }}
                    >
                        {param.id}
                    </label>
                </div>
            ) : param.type === "checkbox" ? (
                <div style={{ paddingTop: "10px" }}>
                    <input
                        id={`${serviceId}-${param.id}`}
                        type="checkbox"
                        checked={isParentChecked}
                        onChange={(e) => handleCheckboxChange(e.target.checked)}
                    />
                    <label
                        className="checkbox-select-label"
                        htmlFor={`${serviceId}-${param.id}`}
                        style={{ marginLeft: "10px", position: "static" }}
                    >
                        {param.id}
                    </label>
                </div>
            ) : (
                <></>
            )}

            {param.type === "checkbox-select" && (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        paddingTop: "15px",
                    }}
                >
                    <div>
                        <input
                            id={`${serviceId}-${param.id}`}
                            type="checkbox"
                            checked={param.enabled}
                            onChange={(e) => handleCheckboxChange(e.target.checked)}
                        />
                        <label
                            className="checkbox-select-label"
                            htmlFor={`${serviceId}-${param.id}`}
                            style={{ marginLeft: "10px", position: "static" }}
                        >
                            {param.id}
                        </label>
                    </div>

                    <Select
                        onChange={handleSelectChange}
                        disabled={!param.enabled}
                        value={param.value}
                        style={{ width: "50%" }}
                    >
                        {param.options.map((option) => (
                            <Option key={option} value={option}>
                                {option}
                            </Option>
                        ))}
                    </Select>
                </div>
            )}

            {param.params && param.params.length > 0 && isScanParamsOpen && (
                <div>
                    {param.params.map((childParam) => (
                        <CheckboxTree
                            key={childParam.id}
                            param={childParam}
                            serviceId={serviceId}
                            updateCheckbox={updateCheckbox}
                            updateSelectParam={updateSelectParam}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};
